import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Avatar,
  Box,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialInput from "../../../components/MaterialInput";
import SimpleTable from "../../../components/SimpleTable";
import { useAuth } from "../../../context/AuthContext";
import { BASE_URL, fetchData, postData } from "../../Utils/Baseurl";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "../../../components/SnackbarProvider";
import ChatBot from "../../chatbot";
import { useLoading } from "../../../context/loadingcontext";
import DynamicTable from "../../../components/Dynamictabel/Dynamictabel";
import { IoSend } from "react-icons/io5";
import ConfirmDialog from "../../../components/ReusableComponent/ConfirmDialog";
import CloseIcon from "@mui/icons-material/Close";

const TaskCareationAccpet = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [comments, setComments] = useState([]);
  const [commentsinput, setCommentsinput] = useState("");
  const [projectcommentid, setProjectcommentid] = useState(0);
  const [projectid, setprojectid] = useState(0);
  const [opencomment, setOpencomment] = useState(false);
  const [chatBotStatus, setChatBotStatus] = useState(false);
  const [suggestion, setSuggestion] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState({
    title: "",
    content: "",
    onConfirm: () => { },
  });
  const navigate = useNavigate();
  const [expandedComments, setExpandedComments] = useState({});
  const [expandedReplies, setExpandedReplies] = useState({});
  const { setCirleLoading } = useLoading();
  const currentUser = sessionStorage.getItem("currentUser");
  const { showSnackbar } = useSnackbar();
  const userColumns = [
    { header: "PROJECT NAME", key: "project_name" },
    { header: "TASK NAME", key: "task_title" },
    { header: "TASK CODE", key: "task_code" },
    { header: "TEAM NAME", key: "teams" },
    { header: "MILESTONE", key: "milestone_name" },
    // { header: "SPRINT", key: "sprint_number" },
    { header: "STATUS", key: "status" },
    { header: "ACTION", key: "action" },
  ];

  useEffect(() => {
    fetchCreationList();
    fetchChatList();
  }, []);

  useEffect(() => {
    if (projectcommentid !== 0) {
      fetchCommentlist();
    }
  }, [projectcommentid]);

  const fetchChatList = async () => {
    const formdata = new FormData();
    formdata.append("user_id", currentUser);
    setCirleLoading(true);

    try {
      const res = await postData("ai/suggest-task/", formdata);
      console.log(res, "res");
      setChatBotStatus(true);
      setSuggestion(res?.message || res?.plan);
    } catch (error) {
      setSuggestion("");
      setChatBotStatus(false);
    } finally {
      setCirleLoading(false);
    }
  };

  const fetchCreationList = async () => {
    setIsLoading(true);
    const currentUser = sessionStorage.getItem("currentUser");
    const formdata = new FormData();

    formdata.append("user_id", currentUser);

    try {
      const data = await postData("api/getEmployeeTask/", formdata);

      if (data?.status) {
        setData(data?.data);
      } else {
        setData([]);
      }
    } catch (error) {
      let message = "An unexpected error occurred";
      if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error?.message) {
        message = error.message;
      }

      showSnackbar(message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCommentlist = async () => {
    setCirleLoading(true);
    try {
      const res = await fetchData(`api/tasks/${projectcommentid}/comments/`);
      console.log(res, "res");
      setComments(res.data);
    } catch (error) {
      console.error(error)
    } finally {
      setCirleLoading(false);
    }
  };
  const handleView = (id, data) => {
    console.log("data", data);
    navigate("/tasklist/view", { state: data });
  };

  const onComment = (id, value) => {
    console.log("value", value);
    setOpencomment(true);
    setProjectcommentid(id);
    setprojectid(value.project);
  };

  const handleCloseDialogComment = () => {
    setOpencomment(false);
    setProjectcommentid(0);
    setComments([]);
  };

  const sendComment = () => {
    setDialogOpen(true);
    setDialogData({
      title: "Are you sure to you want to post this comment?",
      content: "",
      onConfirm: Commentsubmit,
    });
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setDialogData({
      title: "",
      content: "",
      onConfirm: () => { },
    });
  };

  const Commentsubmit = async () => {
    setIsLoading(true);
    let datas = {
      project: projectid,
      comment_text: commentsinput,
      ...(comments.length > 0 && { parent: comments[0].id }),
    };

    try {
      const data = await postData(
        `api/tasks/${projectcommentid}/comments/`,
        datas
      );

      if (data?.status) {
        handleCloseDialog();
        showSnackbar("Comment added Sucessfully", "success");
        setCommentsinput("");
        fetchCommentlist();
      } else {
        setComments([]);
      }
    } catch (error) {
      let message = "An unexpected error occurred";
      if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error?.message) {
        message = error.message;
      }
      showSnackbar(message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleComment = (e) => {
    setCommentsinput(e.target.value);
  };

  const toggleCommentExpand = (index) => {
    setExpandedComments((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const toggleReplyExpand = (commentIndex, replyIndex) => {
    const key = `${commentIndex}-${replyIndex}`;
    setExpandedReplies((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const renderText = (text, expanded, onToggle) => {
    if (text.length <= 100) return text;

    if (expanded) {
      return (
        <>
          {text}{" "}
          <Box
            component="span"
            onClick={onToggle}
            sx={{ color: "blue", cursor: "pointer", userSelect: "none" }}
          >
            Read less
          </Box>
        </>
      );
    } else {
      return (
        <>
          {text.substring(0, 100)}...{" "}
          <Box
            component="span"
            onClick={onToggle}
            sx={{ color: "blue", cursor: "pointer", userSelect: "none" }}
          >
            Read more
          </Box>
        </>
      );
    }
  };
  return (
    <DashboardLayout>
      <ConfirmDialog
        open={dialogOpen}
        title={dialogData.title}
        content={dialogData.content}
        onClose={handleCloseDialog}
        onConfirm={dialogData.onConfirm}
      />
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        p={1}
        mb={2}
      >
        <Stack direction="column" spacing={0}>
          <MaterialTypography variant="h5" fontWeight="medium">
            Task List
          </MaterialTypography>
          <MaterialTypography variant="caption" color="text">
            You can view the task list here.
          </MaterialTypography>
        </Stack>
      </Stack>
      <Dialog
        open={opencomment}
        onClose={handleCloseDialogComment}
        PaperProps={{
          sx: {
            width: "50%",
            height: "auto",
            maxWidth: "none",
          },
        }}
      >
        <DialogTitle
          sx={{ borderBottom: "1px solid #ccc", padding: "8px 16px" }}
        >
          <MaterialTypography
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            variant="h6"
            color="dark"
            fontWeight="bold"
          >
            Task comments{" "}
            <CloseIcon
              onClick={handleCloseDialogComment}
              sx={{ color: "#000", fontSize: "20px", cursor: "pointer" }}
            />
          </MaterialTypography>
        </DialogTitle>
        <DialogContent dividers>
          {comments.length > 0 && (
            // maxHeight: "400px", overflowY: "auto",
            <Box sx={{ pr: 1 }}>
              <Stack spacing={2}>
                {comments.map((c, index) => (
                  <Box key={index}>
                    {/* Main Comment */}
                    <Box display="flex" gap={1} alignItems="flex-start">
                      <Avatar
                        sx={{
                          width: 30,
                          height: 30,
                          "& img": {
                            height: "100%",
                            objectFit: "cover",
                          },
                        }}
                        src={
                          c.commented_by_profile
                            ? BASE_URL + c.commented_by_profile
                            : undefined
                        }
                      >
                        {!c.commented_by_profile &&
                          c.commented_by_username?.charAt(0)}
                      </Avatar>
                      <Box>
                        <MaterialTypography
                          variant="subtitle2"
                          color="dark"
                          sx={{ lineHeight: "1.2" }}
                        >
                          {c.commented_by_username}
                        </MaterialTypography>
                        <MaterialTypography
                          variant="caption"
                          color="gray"
                          sx={{ fontSize: "0.7rem", lineHeight: "1.2" }}
                        >
                          {new Date(c.created_at).toLocaleString()}
                        </MaterialTypography>
                        <MaterialTypography
                          variant="caption"
                          color="text"
                          sx={{ display: "block", mt: 0.5 }}
                        >
                          {renderText(
                            c.comment_text,
                            expandedComments[index],
                            () => toggleCommentExpand(index)
                          )}
                        </MaterialTypography>
                      </Box>
                    </Box>

                    {/* Replies */}
                    <Stack spacing={1} pl={5} mt={1}>
                      {c.replies?.length > 0 &&
                        c.replies?.map((reply, replyIndex) => {
                          const replyKey = `${index}-${replyIndex}`;
                          return (
                            <Box
                              key={replyIndex}
                              display="flex"
                              gap={1}
                              alignItems="flex-start"
                            >
                              <Avatar
                                sx={{
                                  width: 30,
                                  height: 30,
                                  "& img": {
                                    height: "100%",
                                    objectFit: "cover",
                                  },
                                }}
                                src={
                                  reply?.commented_by_profile
                                    ? BASE_URL + reply?.commented_by_profile
                                    : undefined
                                }
                              >
                                {!reply?.commented_by_profile &&
                                  reply?.commented_by_username?.charAt(0)}
                              </Avatar>
                              <Box>
                                <MaterialTypography
                                  variant="subtitle2"
                                  color="dark"
                                  sx={{ lineHeight: "1.2" }}
                                >
                                  {reply.commented_by_username}
                                </MaterialTypography>
                                <MaterialTypography
                                  variant="caption"
                                  color="gray"
                                  sx={{ fontSize: "0.7rem", lineHeight: "1.2" }}
                                >
                                  {new Date(reply.created_at).toLocaleString()}
                                </MaterialTypography>
                                <MaterialTypography
                                  variant="caption"
                                  color="text"
                                  sx={{ display: "block", mt: 0.5 }}
                                >
                                  {renderText(
                                    reply.comment_text,
                                    expandedReplies[replyKey],
                                    () => toggleReplyExpand(index, replyIndex)
                                  )}
                                </MaterialTypography>
                              </Box>
                            </Box>
                          );
                        })}
                    </Stack>
                  </Box>
                ))}
              </Stack>
            </Box>
          )}
        </DialogContent>
        <DialogActions
          sx={{ borderTop: "1px solid #ccc", padding: "8px 16px" }}
        >
          <MaterialInput
            label="Add Comment"
            placeholder="Type your comment here"
            multiline
            rows={2}
            fullWidth
            variant="outlined"
            value={commentsinput}
            onChange={handleComment}
            size="small"
            sx={{ marginRight: 0 }}
            inputProps={{ maxLength: 250 }}
          />
          <IconButton
            onClick={sendComment}
            style={{ opacity: commentsinput == "" ? 0.5 : 1 }}
            disabled={commentsinput == ""}
          >
            <IoSend style={{ fontSize: "20px", color: "#1976d2" }} />
          </IconButton>
        </DialogActions>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mt: 0.5, paddingLeft: 3, mb: 1 }}
        >
          Note: 250 characters allowed
        </Typography>
      </Dialog>
      {chatBotStatus && (
        <div className="chatbox-container">
          <ChatBot suggestionText={suggestion} style={{ marginTop: "-50px" }} />
        </div>
      )}
      <DynamicTable
        columns={userColumns}
        data={data}
        onView={handleView}
        actionVisibility={{
          showEdit: false,
          showView: true,
          showDelete: false,
        }}
        isLoading={isLoading}
        edit={false}
        deleteAction={false}
        onComment={onComment}
      />
    </DashboardLayout>
  );
};

export default TaskCareationAccpet;
